import { createContext, useContext } from 'react'
import type { DialogApi } from './dialog-types'

export const DialogContext = createContext<DialogApi | null>(null)

export function useDialog(): DialogApi {
  const dialog = useContext(DialogContext)
  if (!dialog) throw new Error('useDialog must be used within DialogProvider')
  return dialog
}
